import { _decorator, Component, Sprite, error } from 'cc';
import { DEV } from 'cc/env';
import Delay from '../../Utils/Delay';
import VapVideoManager from './VapVideoManager';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('VapVideoPlayContext')
@requireComponent(Sprite)
export default class VapVideoPlayContext extends Component {
    @property({
        displayName: DEV && 'Vap 名稱',
        tooltip: DEV && 'Vap 名稱 (vapVideoName)',
    })
    protected vapVideoName: string = '';

    @property
    protected shared: boolean = true;

    @property
    protected loop: boolean = false;

    @property
    protected startTime: number = 0;

    @property
    protected autoPlay: boolean = false;

    private _sprite: Sprite = null;

    private get sprite() {
        if (!this._sprite) {
            this._sprite = this.getComponent(Sprite);
        }
        return this._sprite;
    }

    public start() {
        if (this.autoPlay) {
            this.playVap();
        }
    }

    public async playVap(
        vapVideoName: string = this.vapVideoName,
        shared: boolean = this.shared,
        loop: boolean = this.loop,
        startTime: number = this.startTime,
    ) {
        this.vapVideoName = vapVideoName;
        this.shared = shared;
        this.loop = loop;
        this.startTime = startTime;

        const manager = VapVideoManager.Instance;
        if (!manager) {
            error('VapVideoPlayContext: Cannot find VapVideoManager instance.');
            return;
        }

        const spriteFrame = await manager.getVapSpriteFrame(vapVideoName, shared, this, loop, startTime);
        if (!spriteFrame) {
            return;
        }
        this.sprite.spriteFrame = spriteFrame;

        manager.syncVapSprite(this);
        const duration = manager.getVapDuration(vapVideoName);
        const remaining = duration - startTime;
        if (remaining > 0) {
            await Delay.resolve(remaining * 1000);
        }
    }

    public pauseVap() {
        VapVideoManager.Instance?.pauseVap(this);
    }

    public stopVap() {
        VapVideoManager.Instance?.stopVap(this);
    }

    protected onDestroy() {
        this.stopVap();
    }
}
